import { render, staticRenderFns } from "./PaymentPopup.vue?vue&type=template&id=5dd45cc9"
import script from "./PaymentPopup.vue?vue&type=script&lang=js"
export * from "./PaymentPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports